export const stats = {
  general: {
    block: {
      main: 'Звонки',
      acd: 'ACD',
      asr: 'ASR'
    },

    filter: {
      group_by: {
        title: 'Группировать по',
        values: {
          day: 'День',
          month: 'Месяц',
          country: 'Страна'
        }
      },

      type: {
        title: 'Тип',
        values: {
          outgoing: 'Исходящие',
          incoming: 'Входящие'
        }
      },

      source: {
        title: 'Источник данных'
      },

      destination: {
        title: 'Направление'
      },

      voice_stats: {
        trunk: {
          title: 'Транк'
        },
        destination_b_number: {
          title: 'Направление (B-номер)'
        },
        source: {
          title: 'Оригинальный A-номер'
        },
        destination: {
          title: 'Страна'
        }
      }
    },

    field: {
      group: 'Группировка',
      total: 'Итого',
      asr: 'ASR',
      acd: 'ACD',
      duration: 'Длительность',
      duration_billed: 'Тарифицируемая длительность',
      cost: 'Стоимость'
    }
  },

  detailed: {
    field: {
      country: 'Страна',
      source_incoming: 'Оригинальный А-номер',
      source_outgoing: 'Подставленный А-номер',
      destination: 'Направление (B-номер)',
      duration: 'Длительность',
      duration_billed: 'Тарифицируемая длительность',
      cost: 'Стоимость',
      date: 'Дата',
      call_type: 'Тип звонка',
      audio: 'Аудио'
    }
  }
};
